import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import BlogPostForm, { type BlogPostFormData } from '@/components/admin/BlogPostForm'

type Props = {
  post: {
    id: string
    title: string
    slug: string
    excerpt: string
    body: string
    byline: string | null
    blog_category_id: string | null
    tags: string[]
    featured: boolean
    comments_enabled: boolean
    published_at: string | null
    meta_title: string | null
    meta_description: string | null
    cover_image_url: string | null
    og_image_url: string | null
    status: 'draft' | 'published'
  }
  categories: { id: string; name: string; slug: string }[]
  errors?: Partial<Record<string, string[] | string>>
}

export default function AdminBlogPostsEdit({ post, categories, errors }: Props) {
  const initialData: BlogPostFormData = {
    title: post.title,
    slug: post.slug,
    excerpt: post.excerpt,
    body: post.body,
    byline: post.byline || '',
    blog_category_id: post.blog_category_id,
    tags: post.tags || [],
    featured: post.featured,
    comments_enabled: post.comments_enabled,
    published_at: (post.published_at || '').slice(0, 10),
    meta_title: post.meta_title || '',
    meta_description: post.meta_description || '',
    cover_image: null,
    cover_image_preview_url: post.cover_image_url,
    remove_cover_image: false,
    og_image: null,
    og_image_preview_url: post.og_image_url,
    remove_og_image: false,
  }

  return (
    <>
      <Head title={`Admin · Edit ${post.title}`} />
      <BlogPostForm
        initialData={initialData}
        status={post.status}
        categories={categories}
        postId={post.id}
        errors={errors}
      />
    </>
  )
}

AdminBlogPostsEdit.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
